import { ContainerModule } from 'inversify';
import { TYPES } from './iocTypes';
import { ReportDataGathererFactory } from './ReportDataGathererFactory';
import type { IReportLifecycle, IReportRendererFactory } from './interfaces';
import { CreateReportUseCase } from './CreateReportUseCase';
import { RendererFactory } from './RendererFactory';
import { ReportConfigProvider } from './ReportConfigProvider';
import { type IReportConfigProvider, type IReportDataGathererFactory } from './interfaces';
import { ReportLifecycle } from './ReportLifecycle';

export const reportingModule = new ContainerModule((bind) => {
  bind<IReportDataGathererFactory>(TYPES.IReportDataGathererFactory).to(ReportDataGathererFactory);
  bind<IReportConfigProvider>(TYPES.IReportConfigProvider).to(ReportConfigProvider).inSingletonScope();
  bind<IReportRendererFactory>(TYPES.IReportRendererFactory).to(RendererFactory).inSingletonScope();
  bind<CreateReportUseCase>(TYPES.CreateReportUseCase).to(CreateReportUseCase).inSingletonScope();
  bind<IReportLifecycle>(TYPES.IReportLifecycle).to(ReportLifecycle).inSingletonScope();
});
